
export default {
	name: 'DeleteConfirm',
};
